import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types';

class ProfileMenu extends Component{
//    constructor(props){
//        super(props)
//
//    }
//
    render(){
        return(
            <div data-test = 'userProfileMenuComponent' className="user-profile-nav" onClick={this.props.closeOnClick}>
                <div style={{ marginBottom: '10%'}}>
                    <Link to="/profile" className="nav-link" style={{ color : "#abf543"}} >
                        Profile
                    </Link>
                    <button className="nav-link" href="" onClick={this.props.logoutOnClick}  style={{color : "#abf543",fontSize: "100% !important"}}>
                        Logout
                    </button>
                    <Link to="/scenario_manager" className="nav-link" style={{color : "#abf543",fontSize: "100% !important"}}>
                        Scenario Catalogue (Admin View)
                    </Link>
                    <Link to="/bench_manager" className="nav-link" style={{color : "#abf543",fontSize: "100% !important"}}>
                        Bench Manager (Admin View)
                    </Link>

                </div>
            </div>
        )
    }
}
ProfileMenu.propTypes={
closeOnClick:PropTypes.string,
logoutOnClick:PropTypes.string,
}
ProfileMenu.defaultProps= {
closeOnClick:[],
logoutOnClick:[],
}
// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }


export default ProfileMenu

